<template>
  <div>
    <button class="register-button" @click="showFormClick">
      {{buttonText}}
    </button>
    <div id="form" :style="{ display: showForm ? 'block' : 'none' }">
      <div id="cost-info">
        <input type="hidden" id="event-name" v-model="eventName" />
        <div class="ticket-pricing">
          <div class="price">
            <h3>Ticket Price ${{ baseCost }}</h3>
          </div>
        </div>
        <div class='row'>
          <div class="col">
            <b>Parent Name:</b>
            <input type="text" id="parent-name" v-model="parentName" />
          </div>
          <div class="col">
            <b>Phone: </b>
            <input type="tel" id="phone" v-model="phone" placeholder="xxx-xxx-xxxx" />
          </div>    
        </div>
        <div class="row">
          <div class="full-width">
            <b>Email: </b>
            <input type="email" id="email" v-model="email" placeholder="user@email.com" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Address: </b>
            <input type="text" id="address" v-model="street" />
          </div>
          <div class="col">
            <b>City: </b>
            <input type="text" id="city" v-model="city" />
          </div>
        </div>  
        <div class="row">
          <div class="col">
            <b>State: </b>
            <input type="text" id="state" v-model="state" />
          </div>
          <div class="col">
            <b>Zip: </b>
            <input type="text" id="zip" v-model="zip" />
          </div>
        </div>
        <div v-if="kidsEnabled && children.length > 0" class="row">
          <div class="col" style="width:100%;">
            <div v-for="(child, index) in children" class="row"  style="width:100%;" :key="index">
              <div class="col">
                <b>Child's Name: </b>
                <input type='text' id='child-name' v-model="child.name" />
              </div>
              <div v-show="isCamp" class="col">
                <b>Shirt Size: </b>
                <input type="text" id="shirt-size" v-model="child.shirtSize" />
              </div>
              <div v-show="dietEnabled" class="col">
                <b>Dietary Restrictions: </b>
                <input type='text' id='diet' v-model="child.diet" />
              </div>
              <div class="col" style="flex:1;margin-top:5%;">
                <button v-show="index > 0" @click="removeChild(index)" id="remove-child" class="icon-button">
                  <span class="material-icons" style="color:red;">X</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="kidsEnabled" class="row">
          <button @click="addChild" id="add-child" class="button">Add Child</button>
        </div>
        <div class="row">
          <div class="full-width">
            <b>Notes: </b>
            <textarea id="notes" v-model="notes" placeholder="Any additional notes"></textarea>
          </div>
        </div>
        <div id="additional-items" v-if="items.length > 0">
          <h1>Additional Items</h1>
          <p>Here are some additional items:</p>
          <ul id="items">
            <li v-for="(item, index) in items" :key="index" class="item">
              <div class="img-container" v-show="item.Thumbnail?.length > 0">
                <img :src="cleanThumbnail(item)" :alt="item.ItemName" width="100" height="100" />
              </div>
              <b class="cost-title">${{ item.Cost }} - {{ item.ItemName }}</b>
              <div class="item-qty">
                Qty:
                <input type="number" placeholder="0" min="0" v-model="item.Qty" @focus="selectText" />
              </div>
            </li>
          </ul>
        </div>
        <div v-else-if="isLoading === true">
          <p>Loading additional items....</p>
        </div>
        <div class="row">
          <div class="full-width ticket-pricing">
            <h3>
              <b>Grand Total: ${{ total }}</b>
              <input id="grand-total" type="hidden" v-model="total" />
            </h3>
          </div>
        </div>
        <div v-if="hasContactInfo" class="row">
          <div class="full-width">
            Must <strong>ACCEPT</strong> liability waiver and media release to proceed with payment.
          </div>
        </div>
        <div v-if="hasContactInfo" class="row">
          <div class="col">
            <modal class="modal-dialog" height="80%" width="80%" name="liability">
              <div class="modal-action">
                <h1>Liability Waiver</h1>
                <button @click="$modal.hide('liability')" class="icon-button">
                  <span class="material-icons">X</span>
                </button>
              </div>
              <iframe
                :src="`https://gillettefamilyfarms.com/liability?modal=1&${queryString}`"
                frameborder="0"
              ></iframe>
            </modal>
            <div class="legal-form-button">
              <div v-if="liability.checked">
                <span class="material-icons" style="color:green;font-weight:bold;">✓</span>
                Accepted Liability Waiver
              </div>
              <button v-else @click="$modal.show('liability')" id="liability-waiver" class="icon-button">
                <span class="material-icons" style="color:red;font-weight:bold;">X</span>
                View Liability Waiver
              </button>
            </div>
          </div>
          <div class="col">
            <modal class="modal-dialog" height="80%" width="80%" name="media-release">
              <div class="modal-action">
                <h1>Media Release</h1>
                <button @click="$modal.hide('media-release')" class="icon-button">
                  <span class="material-icons">X</span>
                </button>
              </div>
              <iframe
                :src="`https://gillettefamilyfarms.com/media-release-form?modal=1&${queryString}`"
                frameborder="0"
              ></iframe>
            </modal>
            <div class="legal-form-button">
              <div v-if="mediaRelease.checked">
                <span class="material-icons" style="color:green;font-weight:bold;">✓</span>
                Accepted Media Release
              </div>
              <button v-else @click="$modal.show('media-release')" id="media-release" class="icon-button">
                <span class="material-icons" style="color:red;font-weight:bold;">X</span>
                View Media Release
              </button>
            </div>
          </div>
        </div>
        <div v-if="orderStatus === 'success'" class="row">
          <div class="full-width success">
            Successfully submitted your order
          </div>
        </div>
        <div v-show="!isSaving &&!disabled && orderStatus !== 'success'" class="row payment-options">
          <div class="col" style="flex-direction: column;">
            Pay with Credit Card
            <div id="payment-form-row" class="full-width" />
            <div v-if="cardError" class="error">{{ cardError }}</div>
            <button 
              @click="submitPaymentClick" 
              class="register-button" 
              :disabled="!cardComplete || disabled"
            >
              {{ isSaving ? 'Processing...' : 'Submit Payment' }}
            </button>
          </div>
          <div class="col">
            - or -
          </div>
          <div class="col">
            Pay with Venmo
            <div id="venmo-link">
              <a v-if="!isSaving" @click="venmoClick" id='venmo-link' :class="{'disabled': disabled}"> 
                <img src="http://gillettefamilyfarms.com/wp-content/uploads/2025/02/venmo.256x256.png" width="100" alt="Venmo Icon" />
              </a>
            </div>
          </div>
        </div>
        <div v-if="isSaving" class="row">
          <div class="full-width">
            Processing your order, please wait...
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import additionalItemsMixin from '../mixins/additional.items.mixin'
export default {
  name: 'AdditionalItems',
  mixins: [additionalItemsMixin],
}
</script>
<style lang="scss">

.register-button {
  background-color: black;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1em;
  margin-bottom: 20px;
  margin-top: 20px;

  &:disabled {
    background-color: grey;
    cursor: not-allowed;
  }
}

#cost-info {
  display: flex;
  align-items: center;
  flex-direction: column;

  .material-icons {
    font-weight: bold;
    font-family:arial;
  }

  #venmo-link {
    text-decoration: none;
    color: #2c3e50;
    font-size: 1em;
    text-align: center;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;  

    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    img {
      margin-right: 10px;
      vertical-align: middle;
    }
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    width: 60%;

    .success {
      background-color: lightgreen;
      color: green;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin-top: 10px;
      width: 100%;
      padding: 10px;
      border: 1px solid green;
    }

    .icon-button {
      border:0;
      background: transparent;
      cursor: pointer;
    }

    .full-width {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin:10px;

      textarea {
        width: 100%;
        height: 100px;
        resize: none;
        padding: 10px
      }      
    }

    b {
      width: 100%;
      text-align: left;
      margin-bottom: 5px;
    }

    input {
      width: 95%;
      padding: 10px;
      border:1px solid black;
      border-radius: 5px;
    }

    .col {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 50%;
      text-align: center;
      margin:10px;

      .modal-dialog {
        iframe {
          width: 100%;
          height: 70vh;
          border: none;
        }


        .modal-action {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          background-color: #f1f1f1;
          border-radius: 5px;

          button {
            background-color: #e74c3c;
            color: white;
            border: none;
            padding: 10px;
            border-radius: 25px;
            cursor: pointer;

            &:hover {
              background-color: #c0392b;
            }
          }
        }
      }

      .legal-form-button {
        .icon-button {
          display: flex;
          justify-content: center;
          align-items: center;
          text-decoration: none;
          color: #2c3e50;
          font-size: 1em;
          text-align: center;
          margin-top: 10px;
          cursor: pointer;

          span {
            margin-right: 10px;
            vertical-align: middle;
          }
        }
      }

      .mx-datepicker {
        width: 100%;

        input {
          width: 100%;
          padding: 10px;
          border-color: black;
        }
      }
    }
  }

  .ticket-pricing, #grand-total {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    padding: 10px;
    width: 60%;

    input {
      width: 70px;
      max-width: 70px;
    }
  }

  #additional-items {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    display: flex;
    flex-direction: column;
    align-items: center;
    width:100%;

    #items {
      display:flex;
      justify-content: center;
      flex-direction: row;
      width: 80%;
      flex-wrap: wrap;

      .item {
        border: 1px solid #ccc;
        border-radius: 5px;
        padding:10px;
        list-style-type: none;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;;
        width: 175px;
        margin-right: 5px;

        &:hover {
          background-color: #eee;
        }

        .item-qty {
          input {
            padding:10px;
            border:1px solid black;
            border-radius: 5px;
          }
        }

        .img-container {
          position: relative;
          height: 100px;
          width: 100px;
          overflow: hidden;
          display:flex;
          align-items: center;
          border-radius: 5px;

          img {
            position: absolute;
            left: 0px;
          }
        }

        input {
          width: 70px;
          max-width: 70px;
        }
      }
    }
  }  
}

.payment-options {
  width: 100% !important;
}

#payment-form-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  padding: 10px;
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;

  .__PrivateStripeElement {
    width: 100%;
  }
}

@media (max-width: 768px) {
  #payment-form-row {
    width: 100%;
    display: block;
  }

  #cost-info {
    .row {
      width: 100%;
      flex-direction: row;

      .full-width {
        textarea {
          padding: 0px;
        }
      }
    }
  }

  .payment-options {
    flex-direction: column !important;

    .col {
      width: 100% !important;
      margin-bottom: 20px;
    }
  }

  #additional-items {
    #items {
      .item {
        flex-direction: column;
        align-items: center !important;
      }
    }
  }
}
</style>